import { Response, apiAbortController, ChangeLog, Account } from '@ui/src';
import api from '../../../../../../api/api';
import {
  AutoExchangeFormValues,
  AutoExchangeSettings,
  Category,
} from '../types';

export const exchangeAutoSettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getExchangeAutoSettings: build.query<
      Response<AutoExchangeSettings>,
      string
    >({
      query: (query) => ({
        url: `/v1/exchange-auto-rules${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getExchangeAutoSettingsDefault: build.query<
      { data: AutoExchangeSettings },
      void
    >({
      query: () => ({
        url: '/v1/exchange-auto-rules/default',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getExchangeAutoSettingsItem: build.query<
      { data: AutoExchangeSettings },
      string
    >({
      query: (id) => ({
        url: `/v1/exchange-auto-rules/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createExchangeAutoSettingsPair: build.mutation<
      {
        data: AutoExchangeSettings;
      },
      AutoExchangeFormValues
    >({
      query: (data) => ({
        url: '/v1/exchange-auto-rules',
        method: 'POST',
        body: data,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateExchangeAutoSettingsPair: build.mutation<
      {
        data: AutoExchangeSettings;
      },
      { body: AutoExchangeFormValues; id: string }
    >({
      query: (data) => ({
        url: `/v1/exchange-auto-rules/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    changeSettingsStatus: build.mutation<
      {
        data: AutoExchangeSettings;
      },
      { active: boolean; id: string }
    >({
      query: (data) => ({
        url: `/v1/exchange-auto-rules/${data.id}/status`,
        method: 'PUT',
        body: {
          active: data.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRuleChangeLogs: build.query<Response<ChangeLog>, string>({
      query: (query) => ({
        url: `/v1/audit-log${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAutoExchangeAccountsCategories: build.query<Response<Category>, string>({
      query: (query) => ({
        url: `/v1/accounts-categories?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAutoExchangeAccounts: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}&closed=false`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetExchangeAutoSettingsQuery,
  useLazyGetExchangeAutoSettingsItemQuery,
  useCreateExchangeAutoSettingsPairMutation,
  useLazyGetExchangeAutoSettingsDefaultQuery,
  useChangeSettingsStatusMutation,
  useUpdateExchangeAutoSettingsPairMutation,
  useLazyGetRuleChangeLogsQuery,
  useLazyGetAutoExchangeAccountsCategoriesQuery,
  useLazyGetAutoExchangeAccountsQuery,
} = exchangeAutoSettingsApi;

export const {
  endpoints: {
    getExchangeAutoSettings,
    getExchangeAutoSettingsItem,
    createExchangeAutoSettingsPair,
    getExchangeAutoSettingsDefault,
    changeSettingsStatus,
    updateExchangeAutoSettingsPair,
    getRuleChangeLogs,
    getAutoExchangeAccountsCategories,
    getAutoExchangeAccounts,
  },
} = exchangeAutoSettingsApi;
